export const getYear = state => state.reportDriverResults.getIn(['list', 'year'])
export const getData = state => state.reportDriverResults.getIn(['list', 'data'])
export const getFetching = state => state.reportDriverResults.getIn(['list', 'fetching'])
export const getError = state => state.reportDriverResults.getIn(['list', 'error'])

export const getDetailsData = state => state.reportDriverResults.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportDriverResults.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportDriverResults.getIn(['details', 'error'])
